import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import UserDetailedView from './AdminUserDashboard/AdminUserList/UserDetailedView/UserDetailedView';
import { setSelectedUser } from '../../slices/userSlice';
import { useDispatch } from 'react-redux';
import AdminTicketList from './AdminTicketDashboard/AdminTicketList/AdminTicketList';
import Button from '@mui/material/Button';
import './AdminDashboards.scss';
import AdminUserList from './AdminUserDashboard/AdminUserList/AdminUserList';

export default function AdminDashboard() {
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('tickets');
    const selectedUser = useSelector((state) => state.user.selectedUser);

    const handleSave = (updatedUser) => {
    dispatch(setSelectedUser(updatedUser)); // optimistically update Redux
};

useEffect(() => {
        document.body.classList.add("admin-user-dashboard-active");

        return () => {
            document.body.classList.remove("admin-user-dashboard-active");
        };
    }, []);

    return (
        <div className="admin-container">
            <nav className="tab-navbar">
                <nav className="admin-tab-wrapper">
                    <Button
                        className={`admin-tab-item ${activeTab === 'tickets' ? 'active' : ''}`}
                        onClick={() => setActiveTab('tickets')}
                    >
                        All Tickets
                    </Button>
                    <Button
                        className={`admin-tab-item ${activeTab === 'users' ? 'active' : ''}`}
                        onClick={() => setActiveTab('users')}
                    >
                        All Users
                    </Button>
                </nav>
            </nav>

            <div className="admin-content">
                {activeTab === 'tickets' && <AdminTicketList />}
                {activeTab === 'users' && <AdminUserList />}
            </div>
            {selectedUser && (
                <UserDetailedView 
                    selectedUser={selectedUser} 
                    onClose={() => dispatch(setSelectedUser(null))} 
                    onSave={handleSave}
                />
            )}
        </div>
    )
}